import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import PlayModal from "../../components/playModal";
import { useNavigate } from "react-router";
import { getMemberLevel, getUserInfo } from "../../API";
import { useSelector } from "react-redux";
import icon6 from "../../assets/image/icon6.png"

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = React.useState<number>(-1);
  const navigate = useNavigate() 
  const [isShow, setIsShow] = React.useState<boolean>(false)

  const [userInfo, setUserInfo]: any = React.useState({});
  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
    }).catch((err) => {
    });
  }
  const [levelList, setLevelList]: any = React.useState([])
  const handleGetMemberLevel = () => {
    getMemberLevel().then((res) => {
      setLevelList(res.data);
    }).catch((err) => {
    });
  }
  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!token) {
      return
    }
    handleUserInfo()
    handleGetMemberLevel()
  }, [token]);

  return (
    <div className="">
      <TopBar />

      <div className="w-[960px] mx-auto h5:w-full h5:px-[16px]">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4 cursor-pointer" onClick={() => navigate('/account')}>帳戶詳細資料</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">當前會員等級</div>
        </div>
        <br />
        <div className="flex items-center px-[20px] py-[26px] rounded-md h5:px-16"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          <img src={require("../../assets/image/17266777979657.png")} alt=""
            className="w-[60px] mr-10" />
          <div className="flex-1">
            <div className="text-[#595959] text-[16px] pb-10">當前會員等級</div>
            <div className="text-[#181512] text-[26px] font-bold">{userInfo?.membershipLevelDesc}</div>
          </div>
          <div className="">
            <div className=" text-[#181512] text-[26px] font-bold">{userInfo?.balance?.toLocaleString()}</div>
            <div className="text-[#595959] text-[16px] pb-10 text-center">餘額</div>
          </div>
        </div>

        <div className=" rounded-md mt-20 px-[20px] py-[26px] h5:px-16"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          {
            levelList && levelList.map((item: any, index: number) => {
              return <div key={index}>
                <div className="flex items-center py-4"
                  onClick={() => setTabIndex(tabIndex === item?.id ? 0 : item?.id)}>
                  <img src={require("../../assets/image/icon26.png")} alt=""
                    className={`w-[18px] mr-10`} />
                  <div className="flex-1 font-bold">{item?.name}</div>
                  <div className="text-[#181512] text-[16px]">{item?.standardAmount?.toLocaleString()} USD</div>
                  <img src={require("../../assets/image/icon1.png")} alt=""
                    className={`${tabIndex === item?.id ? ' rotate-[90deg]' : ''} w-[14px] ml-10`} />
                </div>
                <div className={`${tabIndex === item?.id ? 'block' : 'hidden'} pt-10`}>
                  <div className="flex">
                    <div className="flex-1 text-[#595959] text-[16px]">商品回饋</div>
                    <div className="text-[#595959] text-[16px]">{item?.discount || '0'}折</div>
                  </div>
                  <div className="flex">
                    <div className="flex-1 text-[#595959] text-[16px] py-4">營業額分潤</div>
                    <div className="text-[#595959] text-[16px]">{item?.revenueSharing || '0'}%</div>
                  </div>
                  <div className="flex pb-10">
                    <div className="flex-1 text-[#595959] text-[16px]">回饋金額</div>
                    <div className="text-[#595959] text-[16px]">{item?.refundAmount || '0'} USD</div>
                  </div>
                  <a className="hidden" href="https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5" target="_blank" rel="noopener noreferrer">
                    <div className="bg-[#595959] rounded-[4px] text-center py-[10px] mt-16 text-[#fff] text-[18px] cursor-pointer
                        hover:bg-[#000]"
                      onClick={() => {
                        // setIsShow(true)
                      }}>
                      {/* 當前等級 */}
                      立即升級
                    </div>
                  </a>
                </div>
                {
                  levelList && levelList.length === index + 1 ? '' : <div className="h-[1px] bg-[#0003] my-10"></div>
                }

              </div>
            })
          }
        </div>

        <div className=" rounded-md mt-20 px-[20px] py-[26px] h5:px-16"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          <div className="text-[#181512] text-[26px] font-bold pb-10">溫馨提示：</div>
          <div className="text-[#595959] text-[16px] pb-10">
            1. 會員等級根據充值金額自動升級 <br />
            2. 等級永久有效，不會降級 <br />
            3. 升級後即可享受相應等級權益</div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
      {/* <PlayModal isShow={isShow} onChange={() => { setIsShow(false) }} /> */}
      <Footer />
    </div>
  );
};

export default ComponentName;
